import { useRef } from 'react'
import { ChevronRight, ChevronLeft } from 'lucide-react'

const SCROLL_OFFSET = 200

interface ScrollNavProps {
  children: React.ReactNode
}

export function ScrollNav({ children }: ScrollNavProps) {
  const scrollContainerRef = useRef<HTMLDivElement>(null)

  const scroll = (direction: 'left' | 'right') => {
    if (!scrollContainerRef.current) return
    const offset = direction === 'right' ? SCROLL_OFFSET : -SCROLL_OFFSET
    scrollContainerRef.current.scrollBy({ left: offset, behavior: 'smooth' })
  }

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={() => scroll('left')}
        className="w-4 h-4 text-gray-600 cursor-pointer hover:text-gray-900 flex-shrink-0 p-0 border-0 bg-transparent flex items-center justify-center"
        aria-label="Rolar para esquerda"
      >
        <ChevronLeft className="w-4 h-4" />
      </button>
      <div
        ref={scrollContainerRef}
        className="flex items-center gap-2 overflow-x-auto scrollbar-hide flex-1"
      >
        {children}
      </div>
      <button
        type="button"
        onClick={() => scroll('right')}
        className="w-4 h-4 text-gray-600 cursor-pointer hover:text-gray-900 flex-shrink-0 p-0 border-0 bg-transparent flex items-center justify-center"
        aria-label="Rolar para direita"
      >
        <ChevronRight className="w-4 h-4" />
      </button>
    </div>
  )
}
